import CircularProgress from "@mui/material/CircularProgress";
import React from "react";

export const Loader = () => {
    return <CircularProgress size="2rem"/>
}